import React, { useMemo } from 'react'

import { Accordion } from '@cox/core-ui8/dist/Accordion'
import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'

import { useInversionData } from '../../../hooks/useInversionData'
import { getInversionTokenValues } from '../../../utils/inversion-util'
import { BaseAccordionCFType, Elements } from '../types'

const CFAccordion = ({
  elementsOrder,
  elements,
  expandedItems,
  accordionIcon,
  singleExpansion,
  variation,
  enableFAQs,
  fragmentitems,
  fragmentAccordions,
  isContentFragment,
  manualitems,
  removePadding
}: any) => {
  const inversionItems = useInversionData()
  const newItems = useMemo(() => inversionItems, [inversionItems])
  const { appData } = useAppDataContext()
  const isLocal = appData?.page?.isLocal
  const invTokenregex = /\[\[(?!token|offer)[^\]]+\]\]/g

  if (fragmentitems) {
    /** ACCORDION_VARIATION.BASE */
    const output: BaseAccordionCFType[] = []
    fragmentAccordions?.map((fragmentAccordion: { title: any; description: any }) => {
      let { title, description } = fragmentAccordion
      if (title || description) {
        if (isLocal) {
          if (invTokenregex.test(title) || invTokenregex.test(description)) {
            title = getInversionTokenValues(title, newItems)
            description = getInversionTokenValues(description, newItems)
          }
        }
        output.push({ title, description })
      }
    })
    return (
      <Accordion
        removePadding={removePadding}
        accordionIcon={accordionIcon}
        variation={variation}
        accordionItems={output}
        alwaysOpen={!singleExpansion}
        defaultActiveKey={expandedItems}
        enableFAQs={enableFAQs}
      />
    )
  } else if (isContentFragment && !manualitems) {
    /** ACCORDION_VARIATION.BASE */
    const output: BaseAccordionCFType[] = []
    for (let i = 0; i < elementsOrder.length; i += 2) {
      const titleKey = elementsOrder[i]
      const descKey = elementsOrder?.[i + 1]
      let title = elements?.[titleKey as keyof Elements]?.value ?? ''
      let description = elements?.[descKey as keyof Elements]?.value ?? ''
      if (title || description) {
        if (isLocal) {
          const matchTitle =
            title.includes('[[') && title.includes(']]') && !title.includes('[[token.') && !title.includes('[[offer.')
          if (matchTitle || invTokenregex.test(description)) {
            title = getInversionTokenValues(title, newItems)
            description = getInversionTokenValues(description, newItems)
          }
        }
        output.push({ title, description })
      }
    }
    return (
      <Accordion
        removePadding={removePadding}
        accordionIcon={accordionIcon}
        variation={variation}
        accordionItems={output}
        alwaysOpen={!singleExpansion}
        defaultActiveKey={expandedItems}
        enableFAQs={enableFAQs}
      />
    )
  }
  return null
}

export default CFAccordion
